import request from 'utils/request';

export default async function fetchRepresentatives(): Promise<any> {
  try {
    const { data: result } = await request(
      `/lineDriveService/masterData/distributorRepMapper/persons
      `,
      {
        method: 'GET'
      }
    );

    return result;
  } catch (error) {
    console.log(error.message);
  }
}
